module.exports = __webpack_public_path__ + "media/images/holidaybox/bg-xs-198c25cd443cef5788e1c3b17e4e22be.jpg";